import { IssueTaskCategory, StoreAddressBase, StoreBase } from '@gooduncles/gu-app-schema';

export const DEFAULT_STORE_NAME = '미등록';

export const commerceIssueCategoryKr: Record<string, string> = {
  refund: '환불',
  order: '주문',
  discount: '할인',
  delivery: '추가배송',
  storage: '보관',
  pickup: '회수',
  supply: '매입처매입',
  return: '매입처반품',
  etc: '기타',
};

export const storeBaseInit: Omit<
  StoreBase,
  'storeName' | 'storeNickname' | 'categories' | 'addressDetail' | keyof StoreAddressBase
> = {
  storeCode: '', // storeCode는 Functions에서 덮어쓰기 되므로 빈 문자열로 초기화
  storeEmail: null,
  storeManagerId: null,
  state: 'guest',
  deliverySpotId: 'unregistered',
  paymentMethod: '미정',
  paymentVendor: '기타',
  latestSettledAt: null,
  accessInfo: null,
  deliveryNote: null,
  firstOrderAt: null,
  latestOrderAt: null,
  firstDeliveryDate: null,
  storeType: 'normal',
};

export const costIssueTaskCategories = [IssueTaskCategory.REFUND, IssueTaskCategory.ADDITIONAL_CHARGE];
